import { defineStore } from "pinia";
import { routes } from "@/router/routes";
import {
  getCurrent,
  reqLogin,
  reqLogOut,
  reqRegister,
  reqUpdateUser,
  UserUpdateRequest,
} from "@/api/user/user";
import { GET_TOKEN, REMOVE_TOKEN, SET_TOKEN } from "@/utils/token";
import accessEnum from "@/access/accessEnum";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const userUserStore = defineStore("user", {
  // 持久化配置：避免刷新页面后丢失用户信息
  persist: {
    key: "user-store",
    storage: localStorage,
    paths: [
      "loginUser.userName",
      "loginUser.userAvatar",
      "token",
      "loginUser.userId",
      "loginUser.userProfile",
      "loginUser.email",
      "loginUser.credit",
      "loginUser.accessKey",
      "loginUser.secretKey",
      "loginUser.userRole",
      "loginUser.guideCompleted",
    ],
  },
  state: () => {
    return {
      menuRoutes: routes, //仓库存储生成菜单需要的数组,
      loginUser: {
        userName: "",
        userAvatar: "",
        gender: "",
        userId: "",
        userProfile: "",
        email: "",
        credit: 0,
        accessKey: "",
        secretKey: "",
        userRole: accessEnum.NOT_LOGIN,
        // 引导完成状态：0=未完成，1=已完成
        guideCompleted: 0,
      },
      token: GET_TOKEN(),
      // 请求锁：防止并发获取用户信息
      isFetchingUser: false,
    };
  },
  actions: {
    //用户登录的方法
    async userLogin(data: any) {
      // 登录请求
      const result: any = await reqLogin(data);
      //登录成功->token
      console.log(result);
      if (result.code == 0) {
        //todo 返回更多的字段
        this.loginUser.userName = result.data.userName as string;
        this.loginUser.userAvatar = result.data.userAvatar;
        this.loginUser.guideCompleted = result.data.guideCompleted;
        this.loginUser.gender = result.data.gender;
        this.loginUser.email = result.data.email || "";
        this.loginUser.userRole = result.data.userRole || accessEnum.NOT_LOGIN;
        // 设置userId（登录接口直接返回id字段）
        this.loginUser.userId = String(result.data.id || "");
        // 保存token到localStorage并更新store中的token状态，确保持久化生效
        const token = result.data.token as string;
        SET_TOKEN(token);
        this.token = token; // 修复：更新store中的token状态
        //token持久化
        console.log(this.token);
        //保证当前async函数返回一个成功的promise
        return "ok";
      }
      //失败->错误信息
      return Promise.reject(new Error(result.data));
    },
    //用户注册的方法
    async userRegister(data: any) {
      try {
        const result: any = await reqRegister(data);
        console.log(result.code); // 只有在请求成功时才会执行到这里
        if (result.code == 0) {
          return "ok";
        }
        return Promise.reject(new Error(result.message));
      } catch (error) {
        console.error("注册请求失败:", error); // 打印错误信息
        return Promise.reject(error);
      }
    },
    // 设置完整用户信息
    async setFullUserInfo(userData: any) {
      this.loginUser.userId = userData.id || "";
      this.loginUser.userName = userData.userName || "";
      this.loginUser.userAvatar = userData.userAvatar || "";
      this.loginUser.userProfile = userData.userProfile || "";
      this.loginUser.email = userData.email || "";
      this.loginUser.credit = userData.credit || 0;
      this.loginUser.accessKey = userData.accessKey || "";
      this.loginUser.secretKey = userData.secretKey || "";
      this.loginUser.userRole = userData.userRole || "";
      this.loginUser.guideCompleted = userData.guideCompleted ?? 0;
    },
    // 第一次登录，完成引导页面后，设置引导完成状态  伴随还要更新数据库中的信息
    setGuideCompleted(completed: number) {
      this.loginUser.guideCompleted = completed;
    },
    // 更新用户信息（头像、昵称、简介、邮箱）
    async updateUserInfo(updateData: UserUpdateRequest) {
      try {
        const result: any = await reqUpdateUser(updateData);
        if (result.code == 0) {
          // 更新成功后同步更新本地状态
          if (updateData.userName) {
            this.loginUser.userName = updateData.userName;
          }
          if (updateData.userAvatar) {
            this.loginUser.userAvatar = updateData.userAvatar;
          }
          if (updateData.userProfile) {
            this.loginUser.userProfile = updateData.userProfile;
          }
          if (updateData.email !== undefined) {
            this.loginUser.email = updateData.email;
          }
          return "ok";
        }
        return Promise.reject(new Error(result.message));
      } catch (error) {
        console.error("更新用户信息失败:", error);
        return Promise.reject(error);
      }
    },
    //退出登录
    async userLogout() {
      const result: any = await reqLogOut();
      if (result.code == 0) {
        this.loginUser.userName = "";
        this.token = "";
        REMOVE_TOKEN();
        this.loginUser.userAvatar = "";
        // 清除扩展用户信息
        this.loginUser.userId = "";
        this.loginUser.userProfile = "";
        this.loginUser.email = "";
        this.loginUser.credit = 0;
        this.loginUser.accessKey = "";
        this.loginUser.secretKey = "";
        this.loginUser.userRole = "";
        this.loginUser.guideCompleted = 0;
        return "ok";
      }
      //未登录也能执行这个方法
      if (result.code == 40100) {
        this.loginUser.userName = "";
        this.token = "";
        REMOVE_TOKEN();
        this.loginUser.userAvatar = "";
        // 清除扩展用户信息
        this.loginUser.userId = "";
        this.loginUser.userProfile = "";
        this.loginUser.email = "";
        this.loginUser.credit = 0;
        this.loginUser.accessKey = "";
        this.loginUser.secretKey = "";
        this.loginUser.userRole = accessEnum.NOT_LOGIN;
        this.loginUser.guideCompleted = 0;
        return "ok";
      }
      return Promise.reject(new Error(result.message));
    },
  },
  getters: {},
});
export default userUserStore;
